import { Component } from '@angular/core';
import { CmsNavigationComponent, CmsService } from '@spartacus/core';
import { CmsComponentData, NavigationNode, NavigationService } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-custom-cx-navigation',
  standalone: false,
  templateUrl: './custom-cx-navigation.component.html',
  styleUrls: ['./custom-cx-navigation.component.scss'],
})
export class CustomCxNavigationComponent {
  node$: Observable<NavigationNode> = this.service.createNavigation(this.componentData.data$);

  name$: Observable<string | undefined> = this.componentData.data$.pipe(map((d) => d?.navigationNode?.title));

  styleClass$: Observable<string | undefined> = this.componentData.data$.pipe(map((d) => d?.styleClass));

  uid$ = this.componentData.data$.pipe(map((d) => d?.uid));

  // get current slot in sap spartacus
  // slot$ = this.componentData.data$.pipe(
  //   map(data => data?.slot)
  // );

  constructor(
    protected componentData: CmsComponentData<CmsNavigationComponent>,
    protected service: NavigationService,
    private cmsService: CmsService
  ) {}
}
